// Shared mood-by-color presets — used by the mood-entry overlay and the Experience Panel.
export const MOODS = [
  { id: "regal", label: "Regal", color: "#a855f7" },
  { id: "calm", label: "Calm", color: "#548a88" },
  { id: "grounded", label: "Grounded", color: "#a88854" },
  { id: "tender", label: "Tender", color: "#ad6e6a" },
  { id: "twilight", label: "Twilight", color: "#7c86d6" },
  { id: "meadow", label: "Meadow", color: "#6fa06a" },
];
